import React from 'react';
import CIcon from '@coreui/icons-react';
import {
  cilAddressBook,
  cilBan,
  // cilBriefcase,
  cilChartLine,
  // cilClock,
  // cilCode,
  cilDataTransferDown,
  cilDataTransferUp,
  cilDescription,
  cilLockLocked,
  cilMoney,
  cilNotes,
  cilPeople,
  cilShieldAlt,
  cilSpeedometer,
  cilSpreadsheet,
  cilWallet,
  cilWarning,
} from '@coreui/icons';
import { CNavItem } from '@coreui/react';

const RoutesNav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    type: 'divider',
  },
  {
    component: CNavItem,
    name: 'OTC Orders',
    to: '/otc_orders/list-otc-orders',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
  },
  {
    component: CNavItem,
    name: 'OTC Payments',
    to: '/otc_payments/list-otc-payments',
    icon: <CIcon icon={cilMoney} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
  },

  // {
  //   component: CNavItem,
  //   name: 'Orders',
  //   to: '/orders/list-orders',
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  //   roles: ['ADMIN', 'USER', 'ANALYZE'],
  // },
  {
    component: CNavItem,
    name: 'Quote Access Token',
    icon: <CIcon icon={cilChartLine} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/quote-access-token/list-quote-access-token',
  },
  {
    type: 'divider',
  },
  {
    component: CNavItem,
    name: 'Users',
    icon: <CIcon icon={cilAddressBook} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER'],
    to: '/users/list-users',
  },
  {
    component: CNavItem,
    name: 'Customers',
    icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/customers/list-customers',
  },
  {
    component: CNavItem,
    name: 'Wallets',
    icon: <CIcon icon={cilWallet} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/wallets/list-wallets',
  },
  {
    type: 'divider',
  },
  {
    component: CNavItem,
    name: 'Pix Cash Ins',
    icon: <CIcon icon={cilDataTransferDown} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/pix-cash-ins/list-pix-cash-ins',
  },
  {
    component: CNavItem,
    name: 'Pix Cash Outs',
    icon: <CIcon icon={cilDataTransferUp} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/pix-cash-outs/list-pix-cash-outs',
  },
  {
    component: CNavItem,
    name: 'Pix Infractions',
    icon: <CIcon icon={cilWarning} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/pix-infractions/list-pix-infractions',
  },
  // {
  //   component: CNavItem,
  //   name: 'Payers',
  //   icon: <CIcon icon={cilBriefcase} customClassName="nav-icon" />,
  //   roles: ['ADMIN', 'USER', 'ANALYZE'],
  //   to: '/payers/list-payers',
  // },

  // {
  //   type: 'divider',
  // },
  // {
  //   component: CNavItem,
  //   name: 'OTC Order Transfers',
  //   to: '/otc_order_transfers/list-otc-order-transfers',
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  //   roles: ['ADMIN', 'USER', 'ANALYZE'],
  // },
  // {
  //   component: CNavItem,
  //   name: 'OTC Payment Transfers',
  //   to: '/otc_payment_transfers/list-otc-payment-transfers',
  //   icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  //   roles: ['ADMIN', 'USER', 'ANALYZE'],
  // },
  {
    type: 'divider',
  },

  {
    component: CNavItem,
    name: 'Tiers',
    icon: <CIcon icon={cilShieldAlt} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/tiers/list-tiers',
  },
  {
    component: CNavItem,
    name: 'IP Blocks',
    icon: <CIcon icon={cilBan} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/customer-access-blocks/list-customer-access-blocks',
  },
  {
    component: CNavItem,
    name: 'IP Attempts',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/customer-access-attempts/list-customer-access-attempts',
  },
  {
    component: CNavItem,
    name: 'IP Attack Monitor',
    icon: <CIcon icon={cilShieldAlt} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/customer-access-groups/list-customer-access-groups',
  },
  {
    component: CNavItem,
    name: 'CIDR Suggestions',
    icon: <CIcon icon={cilSpreadsheet} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/customer-access-cidr-suggestions/list-customer-access-cidr-suggestions',
  },
  {
    component: CNavItem,
    name: 'IP Alerts',
    icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/customer-access-alerts/list-customer-access-alerts',
  },
  {
    component: CNavItem,
    name: 'Withdrawals',
    icon: <CIcon icon={cilSpreadsheet} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/withdrawals/list-withdrawals',
  },
  {
    type: 'divider',
  },
  {
    component: CNavItem,
    name: 'Contracts',
    icon: <CIcon icon={cilNotes} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/contracts/list-contracts',
  },
  {
    component: CNavItem,
    name: 'Configurations',
    icon: <CIcon icon={cilLockLocked} customClassName="nav-icon" />,
    roles: ['ADMIN', 'USER', 'ANALYZE'],
    to: '/configs/list-configs',
  },
  // {
  //   component: CNavItem,
  //   name: 'OTC Schedule',
  //   icon: <CIcon icon={cilClock} customClassName="nav-icon" />,
  //   roles: ['ADMIN', 'USER'],
  //   to: '/configs/otc-schedule',
  // },
  {
    type: 'divider',
  },
  // {
  //   component: CNavItem,
  //   name: 'Bank Webhooks',
  //   icon: <CIcon icon={cilCode} customClassName="nav-icon" />,
  //   roles: ['ADMIN', 'USER', 'ANALYZE'],
  //   to: '/bank-webhooks/list-bank-webhooks',
  // },
  // {
  //   component: CNavItem,
  //   name: 'Bank Pix Cash Ins',
  //   icon: <CIcon icon={cilDataTransferDown} customClassName="nav-icon" />,
  //   roles: ['ADMIN', 'USER', 'ANALYZE'],
  //   to: '/bank-pix-cash-ins/list-bank-pix-cash-ins',
  // },
];

export default RoutesNav;
